export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      // minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      paddingBottom: theme.spacing(4),
      background: theme.palette.blue.main,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.blue.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  content: {
    position: 'relative',
    zIndex: 5,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      minWidth: 'initial',
      height: 'initial',
      top: 'initial',
      left: 'initial',
      transform: 'initial',
      paddingBottom: theme.spacing(2),
    },
  },
  desc: {
    color: theme.palette.secondary.main,
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    minWidth: '90%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& > *:first-child': {
      paddingRight: theme.spacing(6),
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      padding: theme.spacing(2),
      paddingTop: 0,
      paddingBottom: theme.spacing(2),
      display: 'block',
      top: 0,
      left: 0,
      transform: 'initial',
    },
  },
});
